import { render } from "./OddTemplates.vue?vue&type=template&id=07788af9&scoped=true"
import script from "./OddTemplates.vue?vue&type=script&lang=js"
export * from "./OddTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07788af9"]])

export default __exports__